import { createSlice } from '@reduxjs/toolkit'

export const CustomerBankDetailsReducer = createSlice({
    name: 'customerBankDetails',
    initialState: {
        customerBankDetails: null,
    },
    reducers: {
        setCustomerBankDetails: (state, action) => { state.customerBankDetails = action.payload },
    },
})

// Action creators are generated for each case reducer function
export const { setCustomerBankDetails } = CustomerBankDetailsReducer.actions

export default CustomerBankDetailsReducer.reducer